$(window).on("scroll", function() {
  if ($(this).scrollTop() > 92) {
    $('.maca-wrap').addClass('fixed');
  } else {
    $('.maca-wrap').removeClass('fixed');
  }
});

//gnb메뉴 선택
// $('.gnb li a').each(function() {
//   let filePath = window.location.pathname; // 현재 창의 주소에서 파일 경로를 가져옴
//   let fileName = filePath.split('/').pop(); // 현재 주소창의 파일 이름 추출
//   let folderPath = filePath.replace('/' + fileName, ''); // 현재 주소창의 파일 이름을 제외한 폴더 경로 추출
//   let folderName = folderPath.split('/').pop(); // 폴더 이름 추출
  
//   let isClickPath = $(this).attr('href').split('/').slice(-2).join('/'); // gnb메뉴에 링크 경로 끝에서 두 개의 경로 추출
//   let secondToLastFolder = isClickPath.split('/').slice(-2, -1).pop(); // 두 번째로 마지막 폴더 추출
  
//   if (secondToLastFolder == folderName || (isClickPath == 'index.html' && fileName == 'index.html')) {
//     $(this).addClass('selected');
//   }
// });

// $(document).on("click", ".gnb li a", function() {
//   $('.gnb li a').removeClass('selected');
//   $(this).addClass('selected');
// });

//mobile navi
// $('.mobile-navi .main-menu li a').each(function() {
//   let filePath = window.location.pathname.split('/').pop(); // 윈도우창 주소 파일 경로만 추출
//   let isClickPath = $(this).attr('href').split('/').pop(); // 클릭한 버튼에 주소
//   if (isClickPath == filePath) {
//     $(this).parent('li').addClass('selected');
//   }
// });

// $(document).on("click", ".mobile-navi .main-menu li a", function() {
//   $('.mobile-navi .main-menu li a').parent('li').removeClass('selected');
//   $(this).parent('li').addClass('selected');
// });


//layer popup 띄우기
const layerPop = (modalName) => {
  $('body').addClass('popup');
  $(modalName).show();
}

//layer popup 닫기
const layerPopClose = (modalName) => {
  $('body').removeClass('popup');
  $(modalName).hide();
}

//공지사항팝업 호출
function addNoticePopClass() {
  let dimmedWrap = document.querySelector('.dimmed-wrap');

  if (!getCookie("popupShownToday")) {
      // Show the pop-up
      dimmedWrap.classList.add('notice-pop');
      console.log('cookie')
  } 

  // 오늘하루 열지 않음
  $(document).on("click", ".notice-pop .layer-btn .btn-today--close", function(e) {
    setCookie("popupShownToday", "true", 1);
    $('.dimmed-wrap').removeClass('notice-pop');
  });

  // 닫기
  $(document).on("click", ".notice-pop .layer-btn .btn-close", function(e) {
    $('.dimmed-wrap').removeClass('notice-pop');
  });

  // Function to set a cookie
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
    console.log('오늘하루 열지 않음')
  }

  // Function to get a cookie
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(nameEQ) === 0) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
  }
}

// 스냅레이어
function showSnack(text) {
  $('.snack-wrap').html(text);
  $('.snack-wrap').fadeIn();
  setTimeout(function(){
    $('.snack-wrap').fadeOut();
  }, 4000);
}

// 검색바
$(document).on("focus", ".search-bar input", function() {
  var $div = $(this).parent();
  $div.addClass('active');
  }).on('blur', function() {
  var $div = $(this).parent();
  $div.removeClass('active');
});

$(document).on("click", ".search-bar .btn", function() {
  // 검색 버튼을 클릭할 때 실행되는 함수
  var $div = $(this).parent(); // 버튼 요소의 부모인 div 요소 선택
  $div.removeClass('active'); // div에서 'active' 클래스 제거
  // $(this).prev('input').val('');
});

$(document).on("keydown", ".search-bar input", function(e) {
  // 엔터 키를 누를 때 실행되는 함수
  if (e.keyCode === 13) { // keyCode 13은 엔터 키를 의미함
    var $div = $(this).parent(); // input 요소의 부모인 div 요소 선택
    $div.removeClass('active'); // div에서 'active' 클래스 제거
    // this.value = '';
  }
});

// 인풋, 텍스트입력시 활성화 표시
$(document).on('focus', '.form-line input, .form-line textarea', function() {
  var $div = $(this).parent();
  $div.addClass('active');
})
$(document).on('blur', '.form-line input, .form-line textarea', function() {
  var $div = $(this).parent();
  $div.removeClass('active');
});

$(document).on('click', '.form-line input, .form-line textarea, .search-bar input', function() {
  var $div = $(this).parent();
  $('.form-line.active, .search-bar.active').not($div).removeClass('active');
});

$(document).on('click', function(event) {
  var $target = $(event.target);
  if (!$target.closest('.form-line').length && !$target.closest('.search-bar').length) {
    $('.form-line, .search-bar').removeClass('active');
  }
});

// 비밀번호 입력 보기
$('.view-password').click(
  function () {
    $(this).toggleClass('on');
    $(this).closest('.form-line').addClass('active');
    var x = $(this).siblings().attr('type');
    if (x === 'password') {
      $(this).siblings().attr('type', 'text')
    } else {
      $(this).siblings().attr('type', 'password')
    }
  }
)

/**
 * input + label click event
 * click 영역 .check-inner
 * input type에 따른 event 분기 처리
 * */
$(document).on('click', '.form-box--unit .check-inner', function() {
  // 이벤트 미적용 처리
  if($(this).hasClass('no-event')) return false;

  var $checkInner = $(this),
      checkbox = $checkInner.find('.checkbox input[type="checkbox"]'),
      radio = $checkInner.find('.radio input[type="radio"]'),
      inputType = $checkInner.find('input').attr('type');

  //console.log("inputType : ", inputType);

  if (inputType === 'checkbox') {
    checkbox.prop('checked', !checkbox.prop('checked'));
    var formBoxUnit = $checkInner.closest('.form-box--unit');
    formBoxUnit.toggleClass('active', checkbox.prop('checked'));
  } else if (inputType === 'radio') {
    if (!radio.prop('checked')) {
      $checkInner.closest('.form-box--unit').siblings().removeClass('active'); // active init
      radio.prop('checked', !radio.prop('checked'));
      var formBoxUnit = $checkInner.closest('.form-box--unit');
      formBoxUnit.addClass('active', checkbox.prop('checked'));
    }
  }
});

// checkbox
//$(document).on('change', '.form-box--unit .check-inner input[type="checkbox"]', function() {
//  var checkbox = $(this).closest('.form-box--unit').find('.checkbox input[type="checkbox"]');
//  var formBoxUnit = $(this).closest('.form-box--unit');
//  formBoxUnit.toggleClass('active', checkbox.prop('checked'));
//});
//
//$(document).on('click', '.form-box--unit .check-inner', function() {
//  var checkbox = $(this).find('.checkbox input[type="checkbox"]');
//  checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
//  var formBoxUnit = $(this).closest('.form-box--unit');
//  formBoxUnit.toggleClass('active', checkbox.prop('checked'));
//});

// radio button tab
$('.radio-tab input[type="radio"]').click(function() {
  var inputValue = $(this).attr('value');
  var targetBox = $("." + inputValue);
  $('.radio-tab--cont .selected').not(targetBox).removeClass('selected');
  $(targetBox).addClass('selected');
});

// 컨텐츠와 연동되는 탭
function contTab ($this, $tabClass) {
  var tab_id = $($this).attr('data-tab');
  $($tabClass).removeClass('selected');
  $("#"+tab_id).addClass('selected');
}

// 함수 정의: 이미지 업데이트
// function profileImgUpdate() {
//   var imageNames = ["01", "02", "03"];
    
//   // 무작위로 이미지 파일 이름 선택
//   var randomIndex = Math.floor(Math.random() * imageNames.length);
//   var randomImageName = imageNames[randomIndex];
  
//   // 이미지 요소의 src 속성 업데이트
//   $("#myImage").attr("src", "/static/v2/images/temp/my/my_thum_type" + randomImageName + ".png");
// }

function profileImgUpdate() {
  var e = ["01", "02", "03"],
  e = e[Math.floor(Math.random() * e.length)];
  return "/static/v2/images/temp/my/my_thum_type" + e + ".png";
}